<template>
  <el-dialog
    ref="container"
    custom-class="disposition-alarm-single"
    :modal-append-to-body="false"
    :title="$t(title)"
    :visible.sync="visible"
    width="980px"
    top="10vh"
  >
    <el-scrollbar wrap-style="height: 60vh;" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="content">
        <MForm ref="form" class="dispose-form" :i18nPath="i18nPath" v-bind="form">
          <template #upload="{ model }">
            <UploadImage :urls="model" />
          </template>
        </MForm>
      </div>
    </el-scrollbar>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('取消') }}</el-button>
      <el-button type="primary" :loading="loading" @click="confirm">
        {{ $t('确定') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Type from '@/store/mutation-type';

import { disposeAlarmInfo } from '@/api/query';

import MForm from '@/components/form/index.vue';
import UploadImage from '@/components/upload/upload-image.vue';

import { arrify, awaitTo } from '@/utils/utils';
import { getFormConfig, getTitle } from './utils/index';
import { isString } from '@/utils/is';

export default {
  components: { MForm, UploadImage },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      i18nPath: 'component.dispositionAlarm',
      title: '设备报警信息',
      visible: false,
      loading: false,
      form: {}
    };
  },
  computed: {
    ...mapState('socket', ['deviceSNMap'])
  },
  methods: {
    ...mapMutations('mqtt', {
      removeAlarmByIds: Type.REMOVE_ALARM_BY_IDS
    }),
    show() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.form?.clearValidate();
      });
    },
    hide() {
      this.loading = false;
      this.visible = false;

      this.$refs.form?.resetFields();

      // Object.assign(this.form.model, {
      //   dispositionTime: Date.now(),
      //   operator: '',
      //   dispositionInfo: '',
      //   dispositionSituation: [],
      //   peoplePictures: [],
      //   devicePictures: [],
      //   objectPictures: []
      // });
    },
    setData(data) {
      const { sn, deviceType } = data;
      const { dynamicInfoMap } = this.deviceSNMap[sn];

      this.form = getFormConfig(deviceType);
      this.title = getTitle(deviceType);

      const dispositionTime = data.dispositionTime || Date.now();
      const dispositionSituation = isString(data.dispositionSituation)
        ? data.dispositionSituation.split(',').filter(Boolean)
        : [];

      const peoplePictures = isString(data.peoplePictures)
        ? data.peoplePictures.split(',').filter(Boolean)
        : [];
      const devicePictures = isString(data.devicePictures)
        ? data.devicePictures.split(',').filter(Boolean)
        : [];
      const objectPictures = isString(data.objectPictures)
        ? data.objectPictures.split(',').filter(Boolean)
        : [];

      const alarmType = data.alarmType || 'normalAlarm';

      Object.assign(this.form.model, {
        ...data,
        alarmType,
        dispositionTime,
        dispositionSituation,
        position: dynamicInfoMap.location_desc,
        peoplePictures,
        devicePictures,
        objectPictures
      });
    },
    async confirm() {
      this.loading = true;

      const [, valid] = await awaitTo(this.$refs.form.validate());

      if (!valid) return (this.loading = false);

      const {
        sn,
        id,
        alarmGroupId: gId,
        operator,
        alarmType,
        dispositionTime,
        dispositionInfo,
        dispositionSituation,
        peoplePictures,
        devicePictures,
        objectPictures
      } = this.form.model;

      const alarmGroupId = gId || id;

      const [err] = await awaitTo(
        disposeAlarmInfo({
          sn,
          ids: arrify(id),
          alarmType,
          alarmGroupId,
          dispositionInfo,
          dispositionTime,
          operator,
          dispositionSituation: dispositionSituation.join(','),
          peoplePictures: peoplePictures.join(','),
          devicePictures: devicePictures.join(','),
          objectPictures: objectPictures.join(',')
        })
      );

      if (!err) {
        this.removeAlarmByIds(id);
        this.hide();
        this.$emit('success');
        this.$message.success(this.$t('已处理'));
      } else {
        console.error('[DeviceMonitor][disposition-alarm]', err);
        this.$message.warning(this.$t('处理失败'));
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.disposition-alarm-single {
  min-width: 800px;

  .content {
    padding: 20px;
  }

  .el-form-item__label {
    &::after {
      content: '：';
    }
  }
}
</style>
